import React from 'react';
/**
 * 오버플로우 인디케이터 컴포넌트
 * 더 많은 미디어가 있을 때 "+N" 형태로 표시
 */ var OverflowIndicator = function(param) {
    var hiddenCount = param.hiddenCount, hiddenImages = param.hiddenImages, hiddenNormalVideos = param.hiddenNormalVideos, hiddenShortFormVideos = param.hiddenShortFormVideos, onClick = param.onClick;
    return /*#__PURE__*/ React.createElement("div", {
        className: "absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex flex-col items-center justify-center hover:bg-opacity-70 transition-all duration-300 rounded-lg",
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center transform hover:scale-110 transition-transform duration-300"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "text-white text-3xl font-bold"
    }, "+", hiddenCount)), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center items-center mt-3 text-white text-sm max-w-[140px] opacity-90"
    }, hiddenImages > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center mx-1.5 mb-1.5 bg-white bg-opacity-20 rounded-full px-2 py-0.5"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-3.5 w-3.5 mr-1",
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
        clipRule: "evenodd"
    })), hiddenImages), hiddenNormalVideos > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center mx-1.5 mb-1.5 bg-white bg-opacity-20 rounded-full px-2 py-0.5"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-3.5 w-3.5 mr-1",
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M4 5a2 2 0 00-2 2v6a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z",
        clipRule: "evenodd"
    })), hiddenNormalVideos), hiddenShortFormVideos > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center mx-1.5 mb-1.5 bg-white bg-opacity-20 rounded-full px-2 py-0.5"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-3.5 w-3.5 mr-1",
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"
    })), hiddenShortFormVideos, " 숏폼")));
};
export default OverflowIndicator;
